import { put, select, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from 'Domain/App/Ducks/Table.duck';
import {
  approveProcessRequest,
  declineProcessRequest,
  getProcesses,
  retryProcessRequest,
} from '../Services/ProcessesService';
import { actions as AppActions } from '../../App/Ducks/App.duck';
import { MESSAGE_SEVERITY_SUCCESS, MESSAGE_SEVERITY_ERROR } from '../../../common/constants';

export const actionTypes = {
  RequestData: '[Processes] Request',
  FulfilledTable: '[Processes] Fulfilled',
  ChangePage: '[Processes] change page',
  SetPageSize: '[Processes] set page size',
  SortTable: '[Processes] Sort',
  ApplyFilter: '[Processes] Apply filter',
  RemoveFilter: '[Processes] Remove filter',
  SetConnectionId: '[Processes] Set connection',
  RetryProcess: '[Processes] Retry process',
  ApproveProcess: '[Processes] Approve process',
  DeclineProcess: '[Processes] Decline process',
};

const initialState = {
  ...tableInitialState,
  connectionId: null,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    case actionTypes.FulfilledTable: {
      return {
        ...state,
        loading: false,
        loaded: true,
        items: action.items.map(item => {
          item.selected = false;
          return item;
        }),
        totalCount: action.totalCount,
      };
    }
    case actionTypes.SetConnectionId: {
      return {
        ...state,
        connectionId: action.connectionId,
      };
    }

    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
  setConnectionId: connectionId => ({
    type: actionTypes.SetConnectionId,
    connectionId,
  }),
  retryProcess: (connectionId, process) => ({
    type: actionTypes.RetryProcess,
    connectionId,
    process,
  }),
  approveProcess: (connectionId, process) => ({
    type: actionTypes.ApproveProcess,
    connectionId,
    process,
  }),
  declineProcess: (connectionId, process) => ({
    type: actionTypes.DeclineProcess,
    connectionId,
    process,
  }),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  function* retryProcess(action) {
    yield retryProcessRequest(action.connectionId, action.process);

    yield put(actions.requestData());
  }

  function* approveProcess(action) {
    let severity = MESSAGE_SEVERITY_SUCCESS;
    try {
      yield approveProcessRequest(action.connectionId, action.process);
    } catch (error) {
      severity = MESSAGE_SEVERITY_ERROR;
    }

    let details = {
      message: 'approveProcess',
      severity: severity,
    };

    yield put(AppActions.displayMessage(details));
    yield put(actions.requestData());
    yield put(AppActions.setLoading(false));
  }

  function* declineProcess(action) {
    let severity = MESSAGE_SEVERITY_SUCCESS;
    try {
      yield declineProcessRequest(action.connectionId, action.process);
    } catch (error) {
      severity = MESSAGE_SEVERITY_ERROR;
    }

    let details = {
      message: 'declineProcess',
      severity: severity,
    };

    yield put(AppActions.displayMessage(details));
    yield put(actions.requestData());
    yield put(AppActions.setLoading(false));
  }

  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestProcessesSaga() {
    const currentState = yield select(state => {
      return state.ProcessesReducer;
    });

    const response = yield getProcesses(
      currentState.connectionId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });

  yield takeLatest(actionTypes.RetryProcess, retryProcess);
  yield takeLatest(actionTypes.ApproveProcess, approveProcess);
  yield takeLatest(actionTypes.DeclineProcess, declineProcess);
}
